// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t1-5";
export var filledCircle = "_t1-4";
export var historyEntry = "_t1-3";
export var messageSideLeft = "_t1-1";
export var messageSideRight = "_t1-2";
export var orderTrackingCarouselWrapper = "_t1-6";
export var orderTrackingInfoContainer = "_t1-0";